/**
 * App Environment Vue Plugin
 *
 * Makes app environment (network, URLs, etc.) from .env available globally in Vue components
 * Usage:
 *   - this.$env.network       // 'FOGO', 'SOLANA', etc.
 *   - this.$env.displayName   // 'FOGO', 'Solana'
 *   - this.$env.urls.cdn      // CDN URL
 *   - this.$env.isMainnet     // true/false
 */

import Vue from 'vue';
import { appEnvironment, AppEnvironment } from '@/shared/appEnvironment';

// Extend Vue type definitions
declare module 'vue/types/vue' {
	interface Vue {
		$env: AppEnvironment;
	}
}

const AppEnvironmentPlugin = {
	install(vue: typeof Vue) {
		// Add $env to Vue prototype
		Object.defineProperty(vue.prototype, '$env', {
			get() {
				return appEnvironment;
			},
		});
	},
};

export default AppEnvironmentPlugin;
